import { BAYS } from '../../../../../constants';

import type { Bays } from '../../../../../utils/types';

export const getRecommendationServices = (bay: Bays) => [
  {
    name: '97151 Assessment',
    code: '97151',
    hcpcsCode: 'H0031',
    frequency: 'weekly',
    required: false,
  },
  {
    name: '97152 Assisting Assessment',
    code: '97152',
    hcpcsCode: 'H0032',
    frequency: 'weekly',
    required: false,
  },
  {
    name: '97153 Direct ABA Technician 1:1',
    code: '97153',
    hcpcsCode: 'H2019',
    frequency: 'weekly',
    required: bay !== BAYS.BAY_2_5,
  },
  {
    name: '97155 Protocol Modification by BCBA',
    code: '97155',
    hcpcsCode: 'H2012',
    frequency: 'weekly',
    required: false,
  },
  {
    name: '97156 Parent Training/Caregiver Support',
    code: '97156',
    hcpcsCode: 'S5110',
    frequency: 'weekly',
    required: false,
  },
  {
    name: '97157 Group Parent Training. 2-8 parents instructed in a group setting',
    code: '97157',
    hcpcsCode: 'S5111',
    frequency: 'weekly',
    required: bay === BAYS.BAY_2_5,
  },
  {
    name: '99366 Care Coordination',
    code: '99366',
    hcpcsCode: '99366',
    frequency: 'weekly',
    required: false,
  },
];
